import React from 'react';

import classNames from 'classnames';

export default function Tags({ tags, noWrap }) {
    if (!tags || !tags.length) {
        return null;
    }

    return (
        <div className={classNames('tw-flex tw-gap-1.5', noWrap ? 'tw-flex-nowrap' : 'tw-flex-wrap')}>
            {tags.map((tag) => (
                <div className="tw-bg-charcoal-15 tw-text-xs tw-text-nowrap tw-font-medium tw-px-1.5 tw-py-1 tw-rounded-lg" key={tag}>
                    {tag}
                </div>
            ))}
        </div>
    );
}
